import React, {Component} from 'react'
import {Button} from "react-bootstrap";
import strings from '../../../strings/localeStrings'
import moment from "moment";
import {Link} from "react-router-dom";
import AdminService from "../../../admin/adminComponents/AdminService";
import noPhoto from '../../../img/default-photo2.png'

export default class AplikacjaMobilna extends Component {

    constructor(props) {
        super(props);

        this.state = {
            lightBoxOpen: false,
            currentImage: 0,
            czytajWiecej: [],
            data: [],
            size: 0,
            loading: true,
            loading2: false,
        };

        this.closeLightbox = this.closeLightbox.bind(this)
    }

    componentWillMount() {
        this.getNews(3)
    }

    getNews(size) {
        AdminService.getNews(size)
            .then(function (response) {
                let res = response.data;
                this.setState({loading: false, loading2: false, data: res, size: this.state.size + 3})
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    expandItem(item, index) {
        this.setState({
            czytajWiecej: {
                ...this.state.czytajWiecej,
                [index]: !this.state.czytajWiecej[index]
            }
        });
    }

    closeLightbox() {
        this.setState({lightboxOpen: false})
    }

    render() {
        return (
            <div className="aktualnosci ramka wynik">
                <div className="row" style={{width: '100%'}}>
                    <div className="col-sm-12 text-left" style={{paddingTop: 75}}>
                        <h2 className="text-center" style={{fontWeight: 'bold'}}>{strings.aktualnosci}</h2>
                        <hr/>
                        <div style={{paddingTop: 25, paddingBottom: 75}}>
                            {this.state.loading ? <div>
                                <div className="loaderDim"
                                     style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                                    className="fa fa-spinner fa-pulse fa-2x fa-fw"
                                    style={{
                                        color: '#58b13d'
                                    }}> </i></div>
                            </div> : <div>{this.state.data === [] ?
                                <div className="text-center" style={{paddingTop: 50, paddingBottom: 50}}><h5>Brak
                                    aktualności</h5></div> : <div>
                                    {this.state.data.content.map((item, index) => {
                                        return <div>
                                            <div className="row news">
                                                <div className="col-sm-4">
                                                    {item.pliki === null || item.pliki.length === 0 ?
                                                        <div className="col-12 text-center"
                                                             style={{paddingBottom: 4}}>
                                                            <Link
                                                                to={'/aktualnosci/' + item.id + '/' + item.dataWpisu.substr(0, 10)}><img
                                                                src={noPhoto}
                                                                className={'aktualnosciImage'}/></Link>
                                                        </div>
                                                        : <div>
                                                            <div className="row">
                                                                {item.pliki.map((item2, i) => {
                                                                    if (i === 0) {
                                                                        return <div className="col-12 text-center"
                                                                                    style={{paddingBottom: 4}}><Link
                                                                            to={'/aktualnosci/' + item.id + '/' + item.dataWpisu.substr(0, 10)}><img
                                                                            src={'data:' + item2.typ + ';base64, ' + item2.dane}
                                                                            className={'aktualnosciImage'}/></Link>
                                                                        </div>
                                                                    }
                                                                })
                                                                }
                                                            </div>
                                                        </div>}
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="data">{moment(item.dataWpisu).format('LLLL')}</div>
                                                    <Link
                                                        to={'/aktualnosci/' + item.id + '/' + item.dataWpisu.substr(0, 10)}>
                                                        <div className="tytul"
                                                             onClick={() => this.expandItem(item, index)}><h4>
                                                            <b>{item.tytul}</b></h4></div>
                                                    </Link>
                                                    <div className="tresc"><span
                                                        dangerouslySetInnerHTML={{__html: item.tresc.length > 600 ? item.tresc.slice(0, 600) + '...' : item.tresc.slice(0, 600)}}></span>
                                                    </div>
                                                    <div className={'text-right small'}>
                                                        <Link
                                                            to={'/aktualnosci/' + item.id + '/' + item.dataWpisu.substr(0, 10)}>
                                                            <span
                                                                style={{color: '#58b13d'}}>Czytaj dalej...</span>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr/>
                                        </div>
                                    })
                                    }</div>}</div>}
                            {!this.state.data.last ?
                                <div className="pokazWiecej" style={{textAlign: 'center'}}>
                                    {this.state.loading2 ?
                                        <span className="loaderDim"
                                              style={{paddingRight: 15}}><i
                                            className="fa fa-spinner fa-pulse fa-2x fa-fw"
                                            style={{
                                                color: '#58b13d'
                                            }}> </i></span> : null}
                                    <Button className="btn pull-center"
                                            style={{
                                                background: '#58b13d',
                                                color: 'white',
                                                marginRight: 25
                                            }}
                                            onClick={() => {
                                                this.setState({loading2: true});
                                                this.getNews(this.state.size + 3)
                                            }}>{strings.wiecejAktualnosci}</Button>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/aktualnosciComponents/AktualnosciComponent.js